import React from 'react'

import {
  BaseContent,
  Button,
  ButtonGroup,
  type ButtonProps,
  Subsection,
} from '@fourthwall/components'
import { useOffersTotal } from '@hooks'
import { routing } from '@utils/routing'

import { useCreateProduct } from '../../../../Product/hooks/useCreateProduct'

export type EmptyProductsApprovalStatusProps = {
  appName: string
}

export const EmptyProductsApprovalStatus = ({ appName }: EmptyProductsApprovalStatusProps) => {
  const offersTotal = useOffersTotal()
  const { openCreateProductModal } = useCreateProduct()

  // loading or has public offers
  if (!offersTotal || !!offersTotal.public) return null

  const status = offersTotal.all === 0 ? 'NO_OFFERS' : 'NO_PUBLIC_OFFERS'

  const props: Record<typeof status, { description: string; button: ButtonProps }> = {
    NO_OFFERS: {
      description: 'You haven’t created any products yet.',
      button: {
        label: 'Create your first product',
        onClick: () => {
          openCreateProductModal()
        },
      },
    },
    NO_PUBLIC_OFFERS: {
      description: `You don’t have any live products to show on ${appName}.`,
      button: {
        label: 'Manage your products',
        to: routing.products.all.self,
      },
    },
  }

  return (
    <Subsection title="Product approval status">
      <BaseContent>{props[status].description}</BaseContent>
      <div style={{ marginTop: 16 }}>
        <ButtonGroup>
          <Button appearance="primary" {...props[status].button} />
        </ButtonGroup>
      </div>
    </Subsection>
  )
}
